import { useState, useEffect } from 'react'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import client from 'api/client'
import { AccessChannel } from 'types'
import useIsMounted from 'ismounted'

export const useWorkspaceChannels = (workspaceId?: string, includeOpenGroups: boolean = false) => {
  const isMounted = useIsMounted()
  const [workspaceChannels, setWorkspaceChannels] = useState<AccessChannel[]>([])

  useEffect(() => {
    if (!workspaceId) return
    client.getWorkspaceChannels(workspaceId, includeOpenGroups || false).then((res) => {
      if (!isMounted.current) {
        return
      }
      if (res.type === SUCCESS_RESPONSE_TYPE) {
        // Filter out Everyone at {company name} until we switch over company accesses to group accesses
        const filteredChannels = res.data.channels.filter((c) => !c.default_group)
        setWorkspaceChannels(filteredChannels)
      }
    })
  }, [workspaceId]) // eslint-disable-line react-hooks/exhaustive-deps

  return workspaceChannels
}
